var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseNavItem',{attrs:{"title":_vm.$t('labels.transactions'),"icon":_vm.$vuetify.icons.values.transactions,"route":_vm.targetRoute,"visible":_vm.visible}})
}
var staticRenderFns = []

export { render, staticRenderFns }